module.exports = __webpack_public_path__ + "fonts/Lato-HeavyItalic.4a1d8c14.ttf";